import axios from "axios";
import Cookies from "js-cookie";
import jwt from "jsonwebtoken";
import IdentityService from "./identityService";

export default class Api {

// RECOMMENDATION
static async getRecommendation(id) {
  const accesstoken = await this.getAccessToken();
  const headers = {
    "Authorization": `Bearer ${accesstoken}`
  }
  const response = await axios.get(
    `${Api.getBaseUrl()}/api/v2/rec/${id}`,
    {headers: headers}
  );
  return response;
}

  static async getUserRecommendations() {
    const accesstoken = await this.getAccessToken();
    const headers = {
      "Authorization": `Bearer ${accesstoken}`
    } 
    const response = await axios.get(
      `${Api.getBaseUrl()}/api/v2/rec/user/getRecommendations`,
      {headers: headers}
    );
    return response;
  }

  static async getUserRecommendationsById(userId) {
    const accesstoken = await this.getAccessToken();
    const headers = {
      "Authorization": `Bearer ${accesstoken}`
    }
    const response = await axios.get(
      `${Api.getBaseUrl()}/api/v2/rec/user/getRecommendations/${userId}`,
      {headers: headers}
    );
    return response;
  }

  static async fetchSpotMetrics(userId) {
    const accesstoken = await this.getAccessToken();
    const headers = {
      "Authorization": `Bearer ${accesstoken}`
    } 
    const response = await axios.get(
      `${Api.getBaseUrl()}/api/v2/rec/user/getSpotMetrics/${userId}`,
      {headers: headers}
    );
    return response;
  }

  static async updateSpot(updatedSpot) {
    const accesstoken = await this.getAccessToken();
    const headers = {
      "Authorization": `Bearer ${accesstoken}`
    }
    const data = {
      name: updatedSpot.name,
      caption: updatedSpot.caption,
      isPublic: updatedSpot.isPublic
    }
    const response = await axios.put(
      `${Api.getBaseUrl()}/api/v2/rec/${updatedSpot.id}`,
      JSON.stringify(data),
      {headers: headers}
    );
    return response;
  }

  static async setSpotPhoto(spotId, photoURL) {
    const accesstoken = await this.getAccessToken();
    const headers = {
      "Authorization": `Bearer ${accesstoken}`
    }
    const data = {
      photoURL: photoURL
    }
    const response = await axios.put(
      `${Api.getBaseUrl()}/api/v2/rec/${spotId}`,
      JSON.stringify(data),
      {headers: headers}
    );
    return response;
  }

  static async deleteRecommendation(id) {
    const accesstoken = await this.getAccessToken();
    const headers = {
      "Authorization": `Bearer ${accesstoken}`
    }
    const response = await axios.delete(
      `${Api.getBaseUrl()}/api/v2/rec/${id}`,
      {headers: headers}
    );
    return response;
  }

  static async createRecommendation(name, city, country, isPublic, tags, caption, mapboxData) {
    const accesstoken = await this.getAccessToken();
    const headers = {
      "Authorization": `Bearer ${accesstoken}`
    }
    const recommendation = {
      name: name,
      city: city,
      country: country,
      isPublic: isPublic.toString(),
    }
    if (tags !== ""){
      recommendation.tags = tags;
    }
    if (caption !== ""){
      recommendation.caption = caption;
    }

    if (mapboxData !== null){
      recommendation.mapboxData = mapboxData;
    }


    const response = await axios.post(
      `${Api.getBaseUrl()}/api/v2/rec/`,
      JSON.stringify(recommendation),
      {headers: headers}
    );
    return response;
  }

  /**
   * This function checks to see if the current access token is valid (not expired)
   * If the access token is expired, use the refresh token to generate new id/access tokens
   * else return original unexpired access token
   * @param {none}
   * @returns {accessToken} Returns valid access token
   */
  static async getAccessToken(){
    let accessToken = Cookies.get("cognito_access_token");
    const idToken = Cookies.get("cognito_id_token");

    const currTime = Date.now().valueOf();              // grab the current time
    const expTime = jwt.decode(accessToken).exp * 1000; // grab the access tokens expiration time and convert it into JS DateTime
    const email = jwt.decode(idToken).email;            // grab the logged in users email

    if (currTime >= expTime){
      try{
        await IdentityService.refreshSession(email);
        accessToken = Cookies.get("cognito_access_token");
      } catch {
        console.log("Couldn't refresh expired token.")
      }
    }

    return accessToken;
  }

  static async getIdToken(){
    var idToken = Cookies.get("cognito_id_token");

    if(!idToken){
      throw new Error("No id token cached");
    }

    const currTime = Date.now().valueOf();              // grab the current time
    const expTime = jwt.decode(idToken).exp * 1000; // grab the access tokens expiration time and convert it into JS DateTime
    const email = jwt.decode(idToken).email;            // grab the logged in users email

    if (currTime >= expTime){
      try{
        await IdentityService.refreshSession(email);
        idToken = Cookies.get("cognito_id_token");
      } catch {
        console.log("Couldn't refresh expired token.")
      }
    }

    return idToken;
  }

  static getUserdataFromIdToken(){
    const idToken = Cookies.get("cognito_id_token");
    return jwt.decode(idToken);
  }

  static async getLoggedInUser() {
    const accesstoken = await this.getAccessToken();

    const header = {
      "Authorization": `Bearer ${accesstoken}`
    };
    
    const response = await axios.get(
      `${Api.getBaseUrl()}/api/v2/user/getLoggedInUser`, 
      //JSON.stringify(params) //NOTE: We have to pass it as a string because our backend parses the string into JSON object
      {header: header}
    ).catch(function(error) {
        if (error.response){
            throw error;
        }
    });
    if(response){
      if(response.status === 200){
        return response.data;
      } else {
        throw new Error(response.status + ":" + response.data);
      }
    } 
  }

  //TODO: We need to protect this call unless user is public
  static async getUser(id) {
    const response = await axios.get(
      `${Api.getBaseUrl()}/api/v2/user/getUser/${id}`
    ).catch(function(error) {
        if (error.response){
            throw error;
        }
        if (response.status !== 200)
            throw new Error(response.status + ":" + response.data);
    });
    if (response.status === 200){
        return response.data;
    }
  }

  static async addUser(username, email, firstName, lastName, isPublic, dOB) {
    const data = {
      userId: username,
      email: email,
      firstName: firstName,
      lastName: lastName,
      isPublic: isPublic,
      dOB: dOB
    }
    
    const response = await axios.post(
      `${Api.getBaseUrl()}/api/v2/user/addUser`,
      JSON.stringify(data)
    ).catch(function(error) {
        if (error.response){
            throw error;
        }
    });
    if(response){
      if(response.status === 200){
        return response.data;
      } else {
        throw new Error(response.status + ":" + response.data);
      }
    } 
  }

  static async searchUser(firstName, lastName, email) {
    const accesstoken = await this.getAccessToken();
    const headers = {
      "Authorization": `Bearer ${accesstoken}`
    }

    const response = await axios.get(
      `${Api.getBaseUrl()}/api/v2/user/searchUser?firstName=${firstName}`,
      {headers: headers}
    ).catch(function(error) {
      if (error.response){
          throw error;
      }
    });
    if(response){
      if(response.status === 200){
        return response.data;
      } else {
        throw new Error(response.status + ":" + response.data);
      }
    } 
  }

  static async searchFriend(firstName, lastName, email) {
    const accesstoken = await this.getAccessToken();
    const headers = {
      "Authorization": `Bearer ${accesstoken}`
    }

    const response = await axios.get(
      `${Api.getBaseUrl()}/api/v2/friends/searchFriend?firstName=${firstName.toLowerCase()}`,
      {headers: headers}
    ).catch(function(error) {
      if (error.response){
          throw error;
      }
    });
    if(response){
      if(response.status === 200){
        return response.data;
      } else {
        throw new Error(response.status + ":" + response.data);
      }
    } 
  }

  static async updateUserPrivacy(isPublic){
    const data = {
      isPublic: isPublic
    }
    const accesstoken = await this.getAccessToken();
    const headers = {
      "Authorization": `Bearer ${accesstoken}`
    }
    const response = await axios.put(
      `${Api.getBaseUrl()}/api/v2/user/updatePrivacy`,
      JSON.stringify(data),
      {headers: headers}
    ).catch(function(error) {
      if (error.response){
          throw error;
      }
    });

    if(response){
      if(response.status === 200){
        return response.data;
      } else {
        throw new Error(response.status + ":" + response.data);
      }
    } 

  }

  // updates the photoURL attribute on Users table in dynamoDB (let's other people see your profile picture)
  static async uploadProfilePic(photoURL){
    const data = {
      photoURL: photoURL
    }
    const accesstoken = await this.getAccessToken();
    const headers = {
      "Authorization": `Bearer ${accesstoken}`
    }
    const response = await axios.put(
      `${Api.getBaseUrl()}/api/v2/user/uploadProfilePic`,
      JSON.stringify(data),
      {headers: headers}
    ).catch(function(error) {
      if (error.response){
          throw error;
      }
    });

    if(response){
      if(response.status === 200){
        return response.data;
      } else {
        throw new Error(response.status + ":" + response.data);
      }
    } 

  }


  // SHARELIST
  static async getSharelists() {
    const accesstoken = await this.getAccessToken();
    const headers = {
      "Authorization": `Bearer ${accesstoken}`
    }
    const response = await axios.get(
      `${Api.getBaseUrl()}/api/v2/sharelist/user/getUserSharelist`,
      {headers: headers}
    );
    return response;
  }

  static async getSavedSharelists() {
    const accesstoken = await this.getAccessToken();
    const headers = {
      "Authorization": `Bearer ${accesstoken}`
    }
    const response = await axios.get(
      `${Api.getBaseUrl()}/api/v2/sharelist/save/user/getSavedSharelist`,
      {headers: headers}
    );
    return response;
  }

  // Get userSharedSharelists
  static async getUserSharedSharelists() {
    const accesstoken = await this.getAccessToken();
    const headers = {
      "Authorization": `Bearer ${accesstoken}`
    }
    const response = await axios.get(
      `${Api.getBaseUrl()}/api/v2/sharelist/user/getUserSharedSharelists`,
      {headers: headers}
    );
    return response;
  }

  static async getSharelist(sharelistId) {
    const accesstoken = await this.getAccessToken();
    const headers = {
      "Authorization": `Bearer ${accesstoken}`
    }
    const response = await axios.get(
      `${Api.getBaseUrl()}/api/v2/sharelist/${sharelistId}`,
      {headers: headers}
    );
    return response;
  }

  static async getSharelistData(sharelistId) {
    const accesstoken = await this.getAccessToken();
    const headers = {
      "Authorization": `Bearer ${accesstoken}`
    }
    const response = await axios.get(
      `${Api.getBaseUrl()}/api/v2/sharelist/${sharelistId}/data/`,
      {headers: headers}
    );
    return response;
  }

  static async getCollectionSpotCount(sharelistId) {
    const accesstoken = await this.getAccessToken();
    const headers = {
      "Authorization": `Bearer ${accesstoken}`
    }
    const response = await axios.get(
      `${Api.getBaseUrl()}/api/v2/sharelist/${sharelistId}/count`,
      {headers: headers}
    );
    return response;
  }

  static async getSharelistsByUserId(userId) {
    const accesstoken = await this.getAccessToken();
    const headers = {
      "Authorization": `Bearer ${accesstoken}`
    }
    const response = await axios.get(
      `${Api.getBaseUrl()}/api/v2/sharelist/user/getUserSharelist/${userId}`,
      {headers: headers}
    );
    return response;
  }

  static async getSharelistPlaces(id) {
    const accesstoken = await this.getAccessToken();
    const headers = {
      "Authorization": `Bearer ${accesstoken}`
    }
    const response = await axios.get(
      `${Api.getBaseUrl()}/api/v2/sharelist/${id}/placesAll`,
      {headers: headers}
    );
    return response;
  }

  static async createSharelist(name, isPublic, caption) {
    const accesstoken = await this.getAccessToken();
    const headers = {
      "Authorization": `Bearer ${accesstoken}`
    }
    const sharelist = {
      name: name,
      isPublic: isPublic,
      caption: caption
    }
    const response = await axios.post(
      `${Api.getBaseUrl()}/api/v2/sharelist/`,
      JSON.stringify(sharelist),
      {headers: headers}
    );
    return response;
  }

  static async addSharelistPlaces(sharelistId, placelist) {
    const accesstoken = await this.getAccessToken();
    const headers = {
      "Authorization": `Bearer ${accesstoken}`
    }
    const data = {
      placeList: placelist
    }
    const response = await axios.put(
      `${Api.getBaseUrl()}/api/v2/sharelist/add/${sharelistId}/places`,
      JSON.stringify(data),
      {headers: headers}
    );
    return response;
  }

  static async updateSharelist(sharelist) {
    const accesstoken = await this.getAccessToken();
    const headers = {
      "Authorization": `Bearer ${accesstoken}`
    }
    const data = {
      name: sharelist.name,
      caption: sharelist.caption,
      isPublic: sharelist.isPublic
    }
    const response = await axios.put(
      `${Api.getBaseUrl()}/api/v2/sharelist/${sharelist.id}`,
      JSON.stringify(data),
      {headers: headers}
    );
    return response;
  }

  static async savePublicSharelist(sharelist) {
    const accesstoken = await this.getAccessToken();
    const headers = {
      "Authorization": `Bearer ${accesstoken}`
    }
    const data = {
      name: sharelist.name,
      caption: sharelist.caption,
      isPublic: sharelist.isPublic
    }
    const response = await axios.post(
      `${Api.getBaseUrl()}/api/v2/sharelist/save/public/${sharelist.id}`,
      JSON.stringify(data),
      {headers: headers}
    );
    return response;
  }

  // Add endpoint for saving a non-public sharelist
  static async saveSharedSharelist(responseData) {
    const accesstoken = await this.getAccessToken();
    const headers = {
      "Authorization": `Bearer ${accesstoken}`
    }
    const data = {
      approved: responseData.isApproved,
    }
    const response = await axios.put(
      `${Api.getBaseUrl()}/api/v2/sharelist/save/shared/${responseData.id}`,
      JSON.stringify(data),
      {headers: headers}
    );
    return response;
  }

  static async shareSharelist(user, sharelist) {
    const accesstoken = await this.getAccessToken();
    const headers = {
      "Authorization": `Bearer ${accesstoken}`
    }
    const data = {
      userId: user.userId,
    }
    const response = await axios.post(
      `${Api.getBaseUrl()}/api/v2/sharelist/share/${sharelist.id}`,
      JSON.stringify(data),
      {headers: headers}
    );
    return response;
  }

  static async getCollectionShares(sharelist) {
    const accesstoken = await this.getAccessToken();
    const headers = {
      "Authorization": `Bearer ${accesstoken}`
    }

    const response = await axios.get(
      `${Api.getBaseUrl()}/api/v2/sharelist/share/get/${sharelist.id}`,
      {headers: headers}
    );
    return response;
  }

  static async deleteSharelist(id) {
    const accesstoken = await this.getAccessToken();
    const headers = {
      "Authorization": `Bearer ${accesstoken}`
    }
    const response = await axios.delete(
      `${Api.getBaseUrl()}/api/v2/sharelist/${id}`,
      {headers: headers}
    );
  }

  static async deleteSharelistPlace(sharelistId,placeId) {
    const accesstoken = await this.getAccessToken();
    const headers = {
      "Authorization": `Bearer ${accesstoken}`
    }
    const response = await axios.delete(
      `${Api.getBaseUrl()}/api/v2/sharelist/${sharelistId}/place/${placeId}`,
      {headers: headers}
    );
  }

  // FRIENDS
  static async followUser(userId){
    const accesstoken = await this.getAccessToken();
    const headers = {
      "Authorization": `Bearer ${accesstoken}`
    }
    const data = {
      userId: userId
    }
    const response = await axios.post(
      `${Api.getBaseUrl()}/api/v2/friends/followUser`,
      JSON.stringify(data),
      {headers: headers}
    );
    return response;
  }

  static async unfollowUser(userId){
    const accesstoken = await this.getAccessToken();
    const headers = {
      "Authorization": `Bearer ${accesstoken}`
    }
    const data = {
      userId: userId
    }
    const response = await axios.post(
      `${Api.getBaseUrl()}/api/v2/friends/unfollowUser`,
      JSON.stringify(data),
      {headers: headers}
    );
    return response;
  }

  static async fetchFriendship(userId){
    const accesstoken = await this.getAccessToken();
    const headers = {
      "Authorization": `Bearer ${accesstoken}`
    }
    const data = {
      userId: userId
    }
    const response = await axios.get(
      `${Api.getBaseUrl()}/api/v2/friends/fetchFriendship/?userId=${userId}`,
      {headers: headers}
    );
    return response;
  }

  static async getFollowCount(userId){
    const response = await axios.get(
      `${Api.getBaseUrl()}/api/v2/friends/followerCount/${userId}`
    );
    return response.data;
  }

  static async getFollowingCount(userId){
    const response = await axios.get(
      `${Api.getBaseUrl()}/api/v2/friends/followingCount/${userId}`
    );
    return response.data;
  }

  static async getFollower(userId){
    const response = await axios.get(
      `${Api.getBaseUrl()}/api/v2/friends/follower/${userId}`
    );
    return response.data;
  }

  static async getFollowing(userId){
    const response = await axios.get(
      `${Api.getBaseUrl()}/api/v2/friends/following/${userId}`
    );
    return response.data;
  }

  static async getFollowerRequests(userId){
    // const accesstoken = Cookies.get("cognito_access_token");
    // const headers = {
    //   "AccessToken": accesstoken
    // }
    const response = await axios.get(
      `${Api.getBaseUrl()}/api/v2/friends/followerReq/${userId}`//,
      // {headers: headers}
    );
    return response.data;
  }

  static async updateFollowerRequest(followerUserId, approved){
    const accesstoken = await this.getAccessToken();
    const headers = {
      "Authorization": `Bearer ${accesstoken}`
    }
    const data = {
      followerUserId: followerUserId,
      approved: approved
    }
    const response = await axios.put(
      `${Api.getBaseUrl()}/api/v2/friends/updateRequest`,
      JSON.stringify(data),
      {headers: headers}
    );
    return response;
  }

  // IMAGES
  static async getPresignedPostUrl(fileName) {
    // const idToken = Cookies.get("cognito_id_token");
    const response = await axios.get(
      `${Api.getBaseUrl()}/api/v2/user/photo/${fileName}/presigned-post-url`
    );
    return response.data;
  }

  static async getImageUrl(fileName) {
    // const idToken = Cookies.get("cognito_id_token");
    const response = await axios.get(
      `${Api.getBaseUrl()}/api/v2/user/${fileName}/image-url`
    );
    return response.data;
  }

  // sets user profile pic in Cognito (let's the user see their own profile picture)
  static async setUserPhotoUrl(photoURL) {
    const accesstoken = await this.getAccessToken();
    const headers = {
      "Authorization": `Bearer ${accesstoken}`
    }
    const params = {
      photoURL: photoURL
    };
    
    const response = await axios.put(
      `${Api.getBaseUrl()}/api/v2/user/photo/update`, 
      JSON.stringify(params), //NOTE: We have to pass it as a string because our backend parses the string into JSON object
      {headers: headers}
    ).catch(function(error) {
        if (error.response){
            throw error;
        }
    });
    return response.data;

  }

  static async setPublicAcl(fileName) {
    // const idToken = Cookies.get("cognito_id_token");
    const response = await axios.post(
      `${Api.getBaseUrl()}/api/v2/user/photo/${fileName}/set-public-acl`
    );
    return response.data;
  }

  static getBaseUrl() {
    const currentUrl = window.location.href;
    const apiUrls = JSON.parse(process.env.REACT_APP_API_URL);
    if (currentUrl.includes("localhost")) {
      return apiUrls["local"];
    } else if (currentUrl.includes("prod.")) {
      console.log("using prod endpoint")
      return apiUrls["prod"];
    } else if (currentUrl.includes("prodeu.")) {
      console.log("using prodeu endpoint")
      return apiUrls["prodeu"];
    } else if (currentUrl.includes("hostingbucket")) {
      console.log("using dev endpoint")
      return apiUrls["dev"];
    } else {
      console.log("using test endpoint")
      return apiUrls["test"];
    }
  }
}
